<template>
  <div v-if="fabricData" class="edit uk-container uk-container-xsmall">
    <a @click.prevent="$router.back()" href="#" class="uk-text-uppercase uk-text-meta">
      <span uk-icon="chevron-left"></span>back to fabrics
    </a>
    <h1 class="uk-heading uk-text-capitalize">Add Fabric</h1>
    <div class="uk-margin">
      <label class="uk-form-label" for="form-stacked-text">Fabric Name</label>
      <div class="uk-form-controls">
        <input class="uk-input" id="form-stacked-text" type="text" v-model="fabricData.name">
      </div>
    </div>
    <div class="uk-margin">
      <label class="uk-form-label" for="form-stacked-text">Fabric Code</label>
      <div class="uk-form-controls">
        <input class="uk-input" id="form-stacked-text" type="text" v-model="fabricData.mfr_code">
      </div>
    </div>
    <div class="uk-margin">
      <label class="uk-form-label" for="form-stacked-text">Frankford Code (retired)</label>
      <div class="uk-form-controls">
        <input class="uk-input" id="form-stacked-text" type="text" v-model="fabricData.frankford_code">
      </div>
    </div>
    <div class="uk-margin">
      <label class="uk-form-label" for="form-stacked-text">Image File Name</label>
      <div class="uk-form-controls">
        <input class="uk-input" id="form-stacked-text" type="text" v-model="fabricData.image">
      </div>
    </div>
    <div class="uk-margin">
      <label class="uk-form-label" for="form-stacked-text">Texture File Name</label>
      <div class="uk-form-controls">
        <input class="uk-input" id="form-stacked-text" type="text" v-model="fabricData.texture">
      </div>
    </div>
    <div class="uk-margin">
      <label class="uk-form-label" for="form-stacked-text">3D Texture Scale Value <span class="uk-badge"
          id="rangeValue">{{ fabricData.fabric_scale }}</span></label>
      <div class="uk-form-controls">
        <input v-model="fabricData.fabric_scale" id="range" class="uk-range uk-width-1-1" type="range" min="0" max="5"
          step=".1" oninput="document.getElementById('rangeValue').innerHTML = this.value">
      </div>
    </div>
    <div class="uk-margin">
      <label class="uk-form-label" for="form-stacked-select">Grade</label>
      <div class="uk-form-controls">
        <select class="uk-select" id="form-stacked-select" v-model="fabricData.grade">
          <option></option>
          <option value="a">Grade A</option>
          <option value="ap">Grade A+</option>
          <option value="b">Grade B</option>
          <option value="c">Grade C</option>
          <option value="d">Grade D</option>
          <option value="e">Grade E</option>
          <option value="f">Grade F</option>
        </select>
      </div>
    </div>
    <div class="uk-margin">
      <label class="uk-form-label" for="form-stacked-select">Manufacturer</label>
      <div class="uk-form-controls">
        <select class="uk-select" id="form-stacked-select" v-model="fabricData.mfr_handle">
          <option></option>
          <option value="recasens">Recasens</option>
          <option value="sunbrella">Sunbrella</option>
          <option value="outdura">Outdura</option>
          <option value="tempotest">Tempotest</option>
        </select>
      </div>
    </div>
    <div class="uk-margin">
      <label class="uk-form-label" for="form-stacked-text">Brand Collection</label>
      <div class="uk-form-controls">
        <input class="uk-input" id="form-stacked-text" type="text" v-model="fabricData.brand_collection">
      </div>
    </div>
    <div class="uk-margin">
      <label class="uk-form-label" for="form-stacked-select">Color Groups</label>
      <div class="uk-form-controls" uk-grid>
        <label v-for="color in colorGroups" :key="color.name" class="uk-text-capitalize">
          <input name="color_group" class="uk-checkbox" type="checkbox" :value="color.name" />
          {{ color.name }}</label>
      </div>
    </div>
    <div class="uk-margin">
      <label class="uk-form-label" for="form-stacked-select">Pattern Groups</label>
      <div class="uk-form-controls" uk-grid>
        <label v-for="pattern in patternGroups" :key="pattern.name" class="uk-text-capitalize">
          <input name="pattern_group" class="uk-checkbox" type="checkbox" :value="pattern.name" />
          {{ pattern.name }}</label>
      </div>
    </div>
    <div class="uk-margin">
      <label class="uk-form-label" for="form-stacked-select">Fabric Equivalents</label>
      <div class="uk-form-controls uk-flex uk-flex-middle" uk-grid>
        <div v-for="fabric in fabricData.equivalents" :key="fabric" class="uk-text-capitalize">
          <input class="uk-input" name="fabric_equiv" type="text" :value="fabric" />
        </div>
        <a class="" uk-tooltip="Add a new equivalent" uk-icon="plus-circle"
          @click="fabricData.equivalents.push('')"></a>
      </div>
    </div>
    <div class="uk-margin">
      <label class="uk-form-label" for="form-stacked-select">Retired Names</label>
      <div class="uk-form-controls uk-flex uk-flex-middle" uk-grid>
        <div v-for="name in fabricData.retired_names" :key="name" class="uk-text-capitalize">
          <input class="uk-input" name="retired_names" type="text" :value="name" />
        </div>
        <a class="" uk-tooltip="Add a retired fabric name" uk-icon="plus-circle"
          @click="fabricData.retired_names.push('')"></a>
      </div>
    </div>
    <div class="uk-margin">
      <label class="uk-form-label" for="form-stacked-text">Pantone Equivalent</label>
      <div class="uk-form-controls">
        <input class="uk-input" id="form-stacked-text" type="text" v-model="fabricData.pantone">
      </div>
    </div>
    <div class="uk-button-group">
      <button @click="addFabric" class="uk-button uk-button-primary">Save</button>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import UIkit from 'uikit';
import fabric from '@/assets/fabric.json'
import axios, { AxiosResponse } from "axios";
axios.defaults.headers.apikey = process.env.VUE_APP_API_KEY;

@Component({
  components: {
    fabric
  },
})
export default class AddView extends Vue {
  checkedColors: any[] | undefined;
  colorGroups: any;
  patternGroups: any;
  fabricData!: typeof fabric;
  data() {
    return {
      fabricData: fabric,
      checkedColors: [],
      colorGroups: [
        { name: 'Beige' },
        { name: 'Black' },
        { name: 'Blue' },
        { name: 'Brown' },
        { name: 'Gold' },
        { name: 'Grey' },
        { name: 'Green' },
        { name: 'Ivory' },
        { name: 'Orange' },
        { name: 'Pink' },
        { name: 'Purple' },
        { name: 'Red' },
        { name: 'Turquoise' },
        { name: 'White' },
        { name: 'Yellow' },
      ],
      patternGroups: [
        { name: 'Solids' },
        { name: 'Stripes' },
        { name: 'Textures' },
        { name: 'Geometrics' },
        { name: 'Tweeds' },
        { name: 'Organic' },
      ],
    }
  }
  mounted() {
    console.log(this.fabricData);
  }

  public async addFabric(): Promise<void> {
    let url = process.env.VUE_APP_API_NODE_URL + "/fabrics";

    // Set array values and replace originals
    this.fabricData.color_group = Array.from(document.querySelectorAll("input[name='color_group']:checked")).map((elem: any) => elem.value)
    this.fabricData.pattern_group = Array.from(document.querySelectorAll("input[name='pattern_group']:checked")).map((elem: any) => elem.value)
    this.fabricData.equivalents = Array.from(document.querySelectorAll("input[name='fabric_equiv']")).map((elem: any) => elem.value)
    this.fabricData.retired_names = Array.from(document.querySelectorAll("input[name='retired_names']")).map((elem: any) => elem.value)

    // Set field handles
    this.fabricData.mfr_handle = (this.fabricData.mfr).toLowerCase();
    if (this.fabricData.mfr_handle == "recasens") {
      this.fabricData.brand = "Recacril";
    } else {
      this.fabricData.brand = this.fabricData.mfr_handle;
    }
    this.fabricData.brand_handle = (this.fabricData.brand).toLowerCase();
    this.fabricData.brand_collection_handle = (this.fabricData.brand_collection).toLowerCase();

    const options = {
      headers: {
        "Content-Type": "application/json",
      }
    };
    const body = JSON.stringify(this.fabricData);
    try {
      const res: AxiosResponse<any> = await axios.post(
        url,
        body,
        options
      );
      console.log(res);
      if (res.status == 201) {
        UIkit.notification({
          message: this.fabricData.mfr_code + " was added to the catalog",
          status: "success"
        });
      }
    } catch (err) {
      console.log(err);
    }
  }
}
</script>

<style scoped>
.uk-grid-margin {
  margin-top: 0px !important;
}
</style>